import React from 'react';

import SvgContainer from '../SvgContainer';

const Info = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100942)">
                <path d="M7.2 4.8C7.2 4.35817 7.55817 4 8 4C8.44183 4 8.8 4.35817 8.8 4.8C8.8 5.24183 8.44183 5.6 8 5.6C7.55817 5.6 7.2 5.24183 7.2 4.8ZM7.2 8C7.2 7.55817 7.55817 7.2 8 7.2C8.44183 7.2 8.8 7.55817 8.8 8V11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8ZM8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100942">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Info;
